import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../Component/modal/Modal";
import qrcode from "qrcode-generator"
import moment from "moment";

const MyOfferPopup = ({ selectedOffer, handleClose, setClaimOffer }) => {
    const { offer, status } = selectedOffer

    const HOW_TO_USE_IT = [
        "Click on the \"Add to my Offer\" button to save the offer to My Offers in your account.",
        "Use the map navigation provided in the business detail within the app to reach the business location. Show this offer to the Business Owner.",
        "Present the Offer QR code for the business owner to scan and apply to your purchase."
    ]
    return (
        <Modal
            isOpen={true}
            onClose={() => handleClose()}
        >
            <div id="placeHolder"></div>
            <div className="sale-popContent-container">
                <div className="modal-event-box-img">
                    <img
                        src={
                            offer?.offerImage &&
                                offer?.offerImage.length > 0
                                ? offer?.offerImage[0].image
                                : "https://bgz-business.s3.us-east-2.amazonaws.com/FreeBusinessImage.jpg"
                        }
                        style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                            borderRadius: "15px",
                            filter: status == 0 ? 'none' : 'grayscale(1)'
                        }}
                    />
                </div>
                <h5 className="saleTitle">{offer?.title}</h5>
                <p style={{ color: "#3CA059", fontSize: "18px", fontWeight: "400" }}>
                    {offer?.tag_line}
                </p>
                <span
                    style={{
                        color: "#FCFCFC",
                        fontSize: "16px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        paddingBottom: "12px",
                    }}
                >
                    <img src="/images/calender.svg" width={16} />
                    <span>{moment(selectedOffer?.start_date).format('Do MMM YYYY')} </span> -{" "}
                    <span>{moment(selectedOffer?.end_date).format('Do MMM YYYY')} </span>
                </span>
                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#fff" }}>
                        Offers
                    </h3>
                    {offer?.description?.map((des, index) => {
                        return (
                            <ol
                                key={index}
                                style={{ listStyle: "outside", marginBottom: '10px', paddingLeft: "20px" }}
                            >
                                <li
                                    style={{ fontSize: "14px", fontWeight: "600", color: "#fff" }}
                                >
                                    <span style={{ fontWeight: "400", color: "#9f9f9f" }}>
                                        {des.value}
                                    </span>
                                </li>
                            </ol>
                        );
                    })}
                </div>
                <div style={{ margin: '30px 0' }}>
                    <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#fff" }}>
                        How to use it
                    </h3>
                    {HOW_TO_USE_IT?.map((des, index) => {
                        return (
                            <ol
                                key={index}
                                style={{ listStyle: "outside", paddingLeft: "20px" }}
                            >
                                <li
                                    style={{ fontSize: "14px", fontWeight: "600", color: "#fff" }}
                                >
                                    Step {index + 1} -{" "}
                                    <span style={{ fontWeight: "400", color: "#9f9f9f" }}>
                                        {des}
                                    </span>
                                </li>
                            </ol>
                        );
                    })}
                </div>

                <h6 style={{ color: "#FFFFFF", fontSize: "18px", fontWeight: "600" }}>
                    Terms & Conditions{" "}
                </h6>
                {offer?.term_conditions?.map((terms, id) => {
                    return (
                        <ol key={id} style={{ listStyle: "outside", paddingLeft: "20px" }}>
                            <li
                                style={{
                                    color: "#9f9f9f",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                }}
                            >
                                {terms.value}
                            </li>
                        </ol>
                    );
                })}
                {status == 0 && <div style={{ margin: '40px auto', width:'fit-content' }}>
                    <button className="business-telBtn" style={{textAlign: 'center'}} onClick={() => {
                        setClaimOffer(selectedOffer.offer)
                        handleClose()
                    }}>
                        Claim Now
                    </button></div>
                }
            </div>
        </Modal>
    );
};

export default MyOfferPopup;
